import React from 'react'

/** Current time, refreshed every `intervalMs` while non-null (null pauses it). */
export function useNow(intervalMs: number | null): number {
  const [now, setNow] = React.useState(() => Date.now())
  React.useEffect(() => {
    if (intervalMs === null) return
    setNow(Date.now())
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
